<template>
  <v-list two-line>
    <div v-if="newsFeedItems.results.length === 0">
      <v-divider></v-divider>
      <v-subheader class="text-capitalize">{{
        newsFeedItems.group
      }}</v-subheader>
      <v-list-item class="pb-4">
        <v-list-item-avatar>
          <v-avatar color="primary">
            <v-icon dark> mdi-newspaper-minus </v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content class="pr-8">
          <v-list-item-title
            v-if="newsFeedItems.group === 'published'"
            class="mb-2"
          >
            {{
              $t("components.newsfeed.newsFeedItem.noPublisedArticlesAvailable")
            }}
          </v-list-item-title>
          <v-list-item-title
            v-if="newsFeedItems.group === 'scheduled'"
            class="mb-2"
          >
            {{
              $t(
                "components.newsfeed.newsFeedItem.noScheduledArticlesAvailable"
              )
            }}
          </v-list-item-title>
          <v-list-item-title
            v-if="newsFeedItems.group === 'drafts'"
            class="mb-2"
          >
            {{
              $t("components.newsfeed.newsFeedItem.noDraftArticlesAvailable")
            }}
          </v-list-item-title>
          <v-list-item-subtitle class="mb-2"></v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </div>

    <v-list-item-group
      v-else
      v-for="(item, index) in newsFeedItems.results"
      :key="index"
      @change="handleGroupSelect(item)"
    >
      <v-divider v-if="index === 0"></v-divider>
      <v-subheader v-if="index === 0">
        <span v-if="newsFeedItems.group === 'drafts'">
          {{ $t("components.newsfeed.newsFeedItem.drafts") }}
        </span>
        <span v-if="newsFeedItems.group === 'scheduled'">
          {{ $t("components.newsfeed.newsFeedItem.scheduled") }}
        </span>
        <span v-if="newsFeedItems.group === 'published'">
          {{ $t("components.newsfeed.newsFeedItem.published") }}
        </span>
      </v-subheader>
      <!-- v-intersect.quiet="{
          handler: infiniteScrolling,
        }" -->
      <v-list-item :id="item.uuid" class="pb-4">
        <v-list-item-avatar>
          <v-img
            v-if="item.main_image"
            :src="getResizedImageSrc(item.main_image.link)"
          ></v-img>

          <v-avatar v-else color="primary">
            <v-icon dark> mdi-newspaper </v-icon>
          </v-avatar>
        </v-list-item-avatar>

        <v-list-item-content color="red" class="pr-8">
          <v-list-item-title class="mb-2"
            >{{ item.title }}
            <v-chip small outlined class="ml-2" v-if="item.pinned"
              ><v-icon small class="mr-2" color="grey"
                >mdi-bookmark-check</v-icon
              >
              {{ $t("components.newsfeed.newsFeedItem.pinnedToTop") }}
            </v-chip>

            <!-- <v-chip
              small
              outlined
              class="ml-2"
              v-if="item.moderation_status !== 'approved'"
            >
              <div v-if="item.moderation_status === 'pending'">
                <span class="text-capitalize">
                  <v-icon
                    small
                    class="mr-2"
                    color="grey"
                    style="padding-bottom: 2px"
                    >mdi-clock</v-icon
                  >
                  {{ item.moderation_status }}
                </span>
                <span>
                  {{ $t("components.newsfeed.newsFeedItem.review") }}
                </span>
              </div>
              <div v-if="item.moderation_status === 'rejected'">
                <span class="text-capitalize">
                  <v-icon
                    small
                    class="mr-2"
                    color="grey"
                    style="padding-bottom: 2px"
                    >mdi-check-circle</v-icon
                  >
                  {{ item.moderation_status }}
                </span>
                <span>
                  {{ $t("components.newsfeed.newsFeedItem.byReview") }}
                </span>
              </div>
            </v-chip> -->
            <v-chip small outlined class="ml-2" v-if="!item.is_editable">
              <span v-if="!item.is_editable">
                <v-icon small class="mr-2" color="grey">mdi-file-find </v-icon>
                {{ $t("components.newsfeed.newsFeedItem.nonEditable") }}
              </span>
            </v-chip>
          </v-list-item-title>
          <v-list-item-subtitle
            class="mb-2"
            v-if="newsFeedItems.group !== 'drafts'"
          >
            <span v-if="item.date_published !== null">
              <span v-if="newsFeedItems.group === 'scheduled'"
                >{{
                  $t("components.newsfeed.newsFeedItem.willBePublished", {
                    date: item.date_published_prettified,
                  })
                }}
              </span>
              <span v-else>{{ item.date_published_prettified }}</span>

              <span class="ml-1">•</span>
            </span>

            <span
              v-if="newsFeedItems.group === 'published'"
              :class="{ 'ml-1': item.date_published !== null }"
            >
              <span v-if="item.views_count === 1"
                >{{
                  $t("components.newsfeed.newsFeedItem.view", {
                    count: item.views_count,
                  })
                }} </span
              ><span v-else
                >{{
                  $t("components.newsfeed.newsFeedItem.views", {
                    count: item.views_count,
                  })
                }}
              </span>
              <span class="ml-1">•</span>
            </span>

            <span :class="{ 'ml-1': item.date_published !== null }">
              {{ item.audience_size }}
              <span>
                {{ $t("components.newsfeed.newsFeedItem.audience") }}
              </span>

              <v-tooltip bottom v-if="newsFeedItems.group === 'published'">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    class="ml-1"
                    style="margin-bottom: 3px"
                    small
                    v-bind="attrs"
                    v-on="on"
                    >mdi-information-outline</v-icon
                  >
                </template>
                <span
                  >{{
                    $t(
                      "components.newsfeed.newsFeedItem.aViewIsCountedAsAnInteractionWithAnArticleDuplicateInteractionsArentCountedTheAudienceIsEstimatedNumberOfBoatsThatCanSeeThisArticle"
                    )
                  }}
                </span>
              </v-tooltip>
            </span>
          </v-list-item-subtitle>
          <v-list-item-subtitle
            class="mb-2"
            v-if="newsFeedItems.group == 'drafts'"
          >
            <span>
              {{ item.audience_size }}
              <span>
                {{ $t("components.newsfeed.newsFeedItem.audience") }}
              </span></span
            >
          </v-list-item-subtitle>
          <v-list-item-subtitle>{{ item.snippet }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
    <v-card-actions v-if="newsFeedItems.next !== null">
      <v-spacer></v-spacer>
      <v-btn @click="loadNewData" v-if="!loadingNewData" text color="primary"
        ><v-icon class="mr-2">mdi-chevron-double-down</v-icon
        >{{ $t("components.newsfeed.newsFeedItem.loadMore") }}
      </v-btn>
      <v-progress-circular
        :size="30"
        :width="3"
        indeterminate
        dark
        color="primary"
        v-if="loadingNewData"
        class="mt-4 mb-4 mx-auto"
      ></v-progress-circular>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-list>
</template>

<script>
export default {
  props: {
    newsFeedItems: {
      type: Object,
      default: Object,
    },
  },
  data: () => ({
    loadingNewData: false,
  }),
  created() {},
  mounted() {},
  computed: {},
  methods: {
    getResizedImageSrc(src) {
      const extansion =
        src.substring(src.lastIndexOf(".") + 1, src.length) || src;

      return `${src.split(extansion)[0]}250x150.${extansion}`;
    },
    loadNewData() {
      this.loadingNewData = true;
      new Promise((resolve, reject) => {
        this.$emit(
          "load-new-data",
          this.newsFeedItems.next,
          this.newsFeedItems.group,
          function (callback) {
            resolve(callback);
          }
        );
      }).then((resp) => {
        this.loadingNewData = false;
      });
    },
    // infiniteScrolling(entries, observer, isIntersecting) {
    //   if (
    //     entries[0].target.id === this.newsFeedItems.uuid &&
    //     this.newsFeedItems.loaded === false
    //   ) {
    //     this.$emit(
    //       "load-new-data",
    //       this.newsFeedItems.next,
    //       this.newsFeedItems.group
    //     );
    //   }
    //   // this.$emit("check-for-new-group-load");
    // },

    handleGroupSelect(item) {
      item.is_editable ? this.$emit("edit", item) : this.$emit("details", item);
    },
  },
};
</script>
<style scoped>
.list-item--background-color {
  background-color: rgba(50, 165, 196, 0.2);
}
</style>
